import { ReactNode } from 'react';

import { TextVariants } from 'ui/components/primitives/Text/Text.enums';

import type { TextProps } from 'ui/components/primitives';

export enum TEXT_BLOCK_CONST {
  TEST_ID = 'text-block',
}

export type TextBlockConfig = {
  icon?: ReactNode;
  iconColor?: string;
  text: string;
  textAlign: TextProps['textAlign'];
  variant:
    | 'display'
    | 'heading'
    | 'title'
    | 'subtitle'
    | 'bodyLargeStandard'
    | 'bodyLargeShort'
    | 'bodySmallStandard'
    | 'bodySmallShort'
    | 'exceptionsAuxiliar'
    | 'exceptionsRestricted';
};

export type TextBlockProps = TextBlockConfig;
